import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2orbuphvsb: FaireBrandEntity = {
  token: "b_2orbuphvsb",
  type: "brand",
  name: "&MERCI",
  avatarUrl:
    "https://cdn.faire.com/fastly/840d9406357c4029ced8d711eeceb39ae392ec42a649bdf4a242be28f57e4bd4.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7bd3746f0299b907d49adf64c4f1bb0f2e6f1c6bc81d8839de28cc1542e6e6a6.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/840d9406357c4029ced8d711eeceb39ae392ec42a649bdf4a242be28f57e4bd4.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7bd3746f0299b907d49adf64c4f1bb0f2e6f1c6bc81d8839de28cc1542e6e6a6.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 197,
  isTopShop: true,
  isInsider: true,
  description:
    "En Merci is a women’s wholesale fashion company that specializes in designing quality garments for women. At En Merci, we believe in empowering women through fashion that is not only on-trend, but also provides essential styling pieces that form the foundation of their unique style. We celebrate the diversity and beauty of women everywhere by inspiring confidence, self-expression, and individuality to everyone who wears our clothes. \n\nOur mission is to be the trusted source for retailers seeking a diverse collection of high-quality and fashionable garments that cater to the dynamic and ever-evolving needs of modern women.  As we continue to expand our presence, we remain committed to redefining the wholesale fashion landscape with innovation, quality, and unparalleled customer experiences. At En Merci, we shape a brighter and more fashionable future.\n \n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:37.418Z",
    importedBy: "entity-db-cli",
  },
};
